import React from 'react';
import {Icon} from 'semantic-ui-react';

export const MoreDetailsLink = ({id, itemTitle, to}) => (
  <a id="more-details" href={to} title={`More details for ${itemTitle}`} target="_blank">
    More details
    <Icon name="external" />
  </a>
);

export default MoreDetailsLink;
